import React from 'react';
import {
  Box,
  Grid,
  Card,
  CardContent,
  CardActions,
  useMediaQuery
} from '@mui/material';
import { useTheme } from '@mui/material/styles';
import Skeleton, { SkeletonTheme } from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';

const TableManagementPageSkeleton = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  return (
    <SkeletonTheme baseColor="#f0f0f0" highlightColor="#e0e0e0">
      <Box
        sx={{
          minHeight: '100vh',
          background: '#f8fafc',
          p: { xs: 2, md: 4 },
        }}
      >
        {/* Header */}
        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 4 }}>
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
            <Skeleton circle width={56} height={56} />
            <Box>
              <Skeleton height={32} width={220} style={{ marginBottom: 6 }} />
              <Skeleton height={16} width={180} />
            </Box>
          </Box>
          <Skeleton height={48} width={130} style={{ borderRadius: '14px' }} />
        </Box>

        {/* Stats Row */}
        <Grid container spacing={2} sx={{ mb: 3 }}>
          {[...Array(4)].map((_, index) => (
            <Grid item xs={6} sm={3} key={index}>
              <Box sx={{
                borderRadius: '16px',
                p: '20px 24px',
                background: 'rgba(255, 255, 255, 0.95)',
                boxShadow: '0 4px 20px rgba(0, 0, 0, 0.06)',
                display: 'flex',
                alignItems: 'center',
                gap: 2,
              }}>
                <Skeleton circle width={44} height={44} />
                <Box>
                  <Skeleton height={28} width={40} style={{ marginBottom: 4 }} />
                  <Skeleton height={12} width={50} />
                </Box>
              </Box>
            </Grid>
          ))}
        </Grid>

        {/* Groups Section */}
        <Box sx={{
          borderRadius: '16px',
          background: 'rgba(255, 255, 255, 0.95)',
          boxShadow: '0 4px 20px rgba(0, 0, 0, 0.06)',
          p: 3,
          mb: 3,
        }}>
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5, mb: 2 }}>
            <Skeleton circle width={36} height={36} />
            <Skeleton height={22} width={120} />
          </Box>
          <Box sx={{ display: 'flex', gap: 1 }}>
            {[...Array(3)].map((_, index) => (
              <Skeleton key={index} height={48} width={160} style={{ borderRadius: '14px' }} />
            ))}
          </Box>
        </Box>

        {/* Search Bar */}
        <Box sx={{ display: 'flex', gap: 2, mb: 3 }}>
          <Skeleton height={40} width={320} style={{ borderRadius: '12px' }} />
          <Box sx={{ display: 'flex', gap: 0.75 }}>
            {[...Array(3)].map((_, index) => (
              <Skeleton key={index} height={32} width={70} style={{ borderRadius: '10px' }} />
            ))}
          </Box>
        </Box>

        {/* Table Cards Grid */}
        <Grid container spacing={{ xs: 2, md: 3 }}>
          {[...Array(isMobile ? 4 : 8)].map((_, index) => (
            <Grid item xs={12} sm={6} md={4} lg={3} key={index}>
              <Card sx={{
                borderRadius: '20px',
                boxShadow: '0 4px 20px rgba(0, 0, 0, 0.06)',
                overflow: 'hidden',
              }}>
                <Box sx={{ p: 2.5, textAlign: 'center', background: '#f1f5f9' }}>
                  <Skeleton circle width={56} height={56} style={{ margin: '0 auto 12px' }} />
                  <Skeleton height={24} width="50%" style={{ margin: '0 auto 8px' }} />
                  <Box sx={{ display: 'flex', justifyContent: 'center', gap: 0.5 }}>
                    <Skeleton height={22} width={60} style={{ borderRadius: '12px' }} />
                    <Skeleton height={22} width={70} style={{ borderRadius: '12px' }} />
                  </Box>
                </Box>
                <CardContent sx={{ p: 2.5 }}>
                  <Skeleton height={14} width="70%" style={{ marginBottom: 8 }} />
                  <Skeleton height={14} width="50%" />
                </CardContent>
                <CardActions sx={{ px: 2, pb: 2, justifyContent: 'center', gap: 0.5 }}>
                  <Skeleton circle width={32} height={32} />
                  <Skeleton circle width={32} height={32} />
                  <Skeleton circle width={32} height={32} />
                  <Skeleton circle width={32} height={32} />
                </CardActions>
              </Card>
            </Grid>
          ))}
        </Grid>
      </Box>
    </SkeletonTheme>
  );
};

export default TableManagementPageSkeleton;
